import * as Yup from 'yup';
import * as moment from 'moment';
import {BIDFORMAT, FORMAT } from '../utils/dateOfBirthValidation';

export function getInitialValues( response, storedData) {
    // set the delivery date
    let date = new Date();
    let plusTwo = date.setDate(date.getDate() + 3);
    let dateSet = new Date(plusTwo)
  
    if(response?.requestedDate){
        dateSet = moment(response?.requestedDate).format(FORMAT)
        // dateSet = moment(new Date(response?.requestedDate * 1000).toLocaleString()).format(FORMAT)
        // const unixSeconds =  response?.requestedDate;
        // const unixMilliSeconds = moment(new Date(response?.requestedDate * 1000).toLocaleString()).format(FORMAT);
        // const myDate = new Date(unixMilliSeconds) / 1000
    }
    //if condition add
    let bidDate = moment(dateSet).format(BIDFORMAT)  

    let brokerFlag = false;
    if(storedData?.data?.userRole === 'BROKER' && response?.postType === "NEED" && response?.shippingMode !== 'PICKUP'){
        brokerFlag = true
    }

    return {
        name: brokerFlag? response?.shippingAddress?.locationName :'',
        line1: brokerFlag? response?.shippingAddress?.address1 :"",
        line2: brokerFlag? response?.shippingAddress?.address2 :"",
        city:  brokerFlag? response?.shippingAddress?.city :"",
        state: brokerFlag? response?.shippingAddress?.state :"",
        zip: brokerFlag? response?.shippingAddress?.zipCode :"",
        bidPrice: '',
        confirmBid: false,
        checkOutDate: bidDate,
        requestedStartTime: response?.appointmentStartTime? response?.appointmentStartTime: '08:00',
        requestedEndTime: response?.appointmentEndTime? response?.appointmentEndTime :'17:00' ,
    }
}

const VALIDATION_SCHEMA = (pageLanguageContents, addressState) => {
    let schemaAttributes

    if(addressState){
        schemaAttributes = {
            name:Yup.string().trim().required("Company name is required."),
            line1:Yup.string().trim().required("Address Line 1 is required."),
            city:Yup.string().trim().required("City is required."),
            state:Yup.string().trim().required("State is required."),
            zip:Yup.string().trim().required("Zip is required."),
            bidPrice: Yup.string().trim().required(pageLanguageContents?.ErrorValidations[4]?.BidReq),
            confirmBid: Yup.boolean().oneOf([true], pageLanguageContents?.ErrorValidations[2]?.SelectCheckbox),
        }
    }else{
        schemaAttributes = {
            bidPrice: Yup.string().trim().required(pageLanguageContents?.ErrorValidations[4]?.BidReq),
            confirmBid: Yup.boolean().oneOf([true], pageLanguageContents?.ErrorValidations[2]?.SelectCheckbox),
        }
    }
        
    return Yup.object().shape(schemaAttributes);
}

export { VALIDATION_SCHEMA };